import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Component } from "react";
import GenericTouchable, { TOUCHABLE_STATE } from "./GenericTouchable";
import { StyleSheet, View } from "react-native";
var TouchableHighlight = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(TouchableHighlight, Component);
    var _super = _create_super(TouchableHighlight);
    function TouchableHighlight(props) {
        _class_call_check(this, TouchableHighlight);
        var _this;
        _this = _super.call(this, props);
        // Copied from RN
        _define_property(_assert_this_initialized(_this), "showUnderlay", function() {
            var _this_props_onShowUnderlay, _this_props;
            if (!_this.hasPressHandler()) {
                return;
            }
            _this.setState({
                extraChildStyle: {
                    opacity: _this.props.activeOpacity
                },
                extraUnderlayStyle: {
                    backgroundColor: _this.props.underlayColor
                }
            });
            (_this_props_onShowUnderlay = (_this_props = _this.props).onShowUnderlay) === null || _this_props_onShowUnderlay === void 0 ? void 0 : _this_props_onShowUnderlay.call(_this_props);
        });
        _define_property(_assert_this_initialized(_this), "hasPressHandler", function() {
            return _this.props.onPress || _this.props.onPressIn || _this.props.onPressOut || _this.props.onLongPress;
        });
        _define_property(_assert_this_initialized(_this), "hideUnderlay", function() {
            var _this_props_onHideUnderlay, _this_props;
            _this.setState({
                extraChildStyle: null,
                extraUnderlayStyle: null
            });
            (_this_props_onHideUnderlay = (_this_props = _this.props).onHideUnderlay) === null || _this_props_onHideUnderlay === void 0 ? void 0 : _this_props_onHideUnderlay.call(_this_props);
        });
        _define_property(_assert_this_initialized(_this), "onStateChange", function(_from, to) {
            if (to === TOUCHABLE_STATE.BEGAN) {
                _this.showUnderlay();
            } else if (to === TOUCHABLE_STATE.UNDETERMINED || to === TOUCHABLE_STATE.MOVED_OUTSIDE) {
                _this.hideUnderlay();
            }
        });
        _this.state = {
            extraChildStyle: null,
            extraUnderlayStyle: null
        };
        return _this;
    }
    _create_class(TouchableHighlight, [
        {
            key: "renderChildren",
            value: function renderChildren() {
                if (!this.props.children) {
                    return /*#__PURE__*/ _jsx(View, {});
                }
                var child = React.Children.only(this.props.children); // TODO: not sure if OK but fixes error
                return /*#__PURE__*/ React.cloneElement(child, {
                    style: StyleSheet.compose(child.props.style, this.state.extraChildStyle)
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, _this_props_style = _this_props.style, style = _this_props_style === void 0 ? {} : _this_props_style, rest = _object_without_properties(_this_props, [
                    "style"
                ]);
                var extraUnderlayStyle = this.state.extraUnderlayStyle;
                return /*#__PURE__*/ _jsx(GenericTouchable, _object_spread_props(_object_spread({}, rest), {
                    style: [
                        style,
                        extraUnderlayStyle
                    ],
                    onStateChange: this.onStateChange,
                    children: this.renderChildren()
                }));
            }
        }
    ]);
    return TouchableHighlight;
}(Component);
_define_property(TouchableHighlight, "defaultProps", _object_spread_props(_object_spread({}, GenericTouchable.defaultProps), {
    activeOpacity: 0.85,
    delayPressOut: 100,
    underlayColor: "black"
}));
/**
 * TouchableHighlight follows RN's implementation
 */ export { TouchableHighlight as default };
